import React, { Fragment, useState, useEffect } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate } from "react-router";
import FCategoryContainer from "../../components/FCategoryContainer/FCategoryContainer";
import FQuickAccessList from "../../components/FQuickAccessList/FQuickAccessList";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";

const MainScreen = ({ param }) => {
  const {
    getProductsShortcuts,
    productsShortcuts,
    goToTransactionCustomizationScreen,
  } = useBillPaymentArcus();

  //const isFocused = useIsFocused();

  useEffect(() => {
    getProductsShortcuts();
    console.log(productsShortcuts);
  }, []);

  const route = useNavigate();
  const arrayCategory = [
    // {
    //   name: "Comparte un Fiado",
    //   imageUrl: require("../../components/assets/images/hands.png"),
    //   onclick: () => {
    //     route("/ShareFiadoScreen");
    //   },
    // },
    {
      name: "Recarga tu celular",
      imageUrl: require("../../components/assets/images/phone.png"),
      onclick: () => {
        route("/RechargeScreen");
      },
    },
    {
      name: "¡Envía un regalo!",
      imageUrl: require("../../components/assets/images/gift.png"),
      onclick: () => {
        route("/GiftCardScreen");
      },
    },
    {
      name: "Paga tus recibos",
      imageUrl: require("../../components/assets/images/bill.png"),
      onclick: () => {
        route("/BillPaymentScreen");
      },
    },
    {
      name: "Retira en efectivo",
      imageUrl: require("../../components/assets/images/cash.png"),
      onclick: () => {
        route("/WithdrawalScreen");
      },
    },

    // More people...
  ];

  const arrayCategory1 = [
    // More people...
  ];
  const action = (product) => {
    goToTransactionCustomizationScreen(product);
  };

  return (
    <>
      <div className="pb-24">
        <FCategoryContainer arrayCategory={arrayCategory1} />
        <FCategoryContainer arrayCategory={arrayCategory} />
        <div className="font-bold text-lg sm:text-3xl">{"Acceso Rápido"}</div>
        <div class="flex overflow-x-auto space-x-8 w-1/1 ">
          <FQuickAccessList
            productsShortcuts={productsShortcuts?.products}
            action={action}
          />
        </div>
      </div>
    </>
  );
};

export default MainScreen;
